<template>
  <div id="homework">
    <BottomBar />
    <Empty
      v-if="!data"
      :loading="data === undefined"
      :error="error"
      :icon="true"
      title="无数据"
      subtitle="找不到该课后作业"
    />
    <div v-else class="detail">
      <router-link tag="div" to="/homework" class="back">
        <i class="anyteachicon anyteach-arrow-left" />更多作业
      </router-link>
      <div class="exam">
        <div class="flex top">
          <div class="flex">
            <div class="title">
              <h3>
                <StudentName v-bind="student" hide-age />
                <span>的课后作业</span>
              </h3>
              <router-link v-if="schedule" tag="h5" :to="'/schedule/view/' + schedule.id">
                {{ schedule.title }}
              </router-link>
            </div>
          </div>
          <div v-if="homework.status > 0" class="status" :class="'status-' + homework.status">
            <i
              v-if="homeworkStatus[homework.status].icon"
              :class="homeworkStatus[homework.status].icon"
            />
            {{ homeworkStatus[homework.status].title }}
          </div>
        </div>
        <Sect title="老师">
          <div class="teacher">
            <div class="img" :style="$bgd(teacher.gravatar)" />
            <span>{{ teacher.name }}</span>
          </div>
        </Sect>
        <Sect title="时间">
          <div class="flex">
            <div>
              <div>{{ classDate }}</div>
              <div>{{ classTime }}</div>
            </div>
            <router-link tag="a" :to="scheduleTimeUrl">
              <i class="anyteachicon anyteach-view" />
              <span>查看</span>
            </router-link>
          </div>
        </Sect>
        <Sect title="作业">
          <div
            v-for="item in homework.schedule_time.homework"
            :key="item.p_id"
            class="homework-item"
          >
            <div class="lesson">{{ getLessonTitle(getLessonById(item.p_id)) }}</div>
            <div class="html-content">
              <div
                v-if="item.homework && item.homework.length"
                v-html="item.homework"
                class="html"
              />
              <div v-else v-html="getLessonById(item.p_id).lesson.homework" class="html" />
            </div>
          </div>
        </Sect>
      </div>
    </div>
  </div>
</template>

<script>
import Sect from "@/components/exam/Sect"
import StudentName from "@/components/public/StudentName"
import { homeworkStatus } from "./utils"
export default {
  name: "HomeworkInfo",
  components: {
    Sect,
    StudentName
  },
  data() {
    return {
      homeworkStatus,
      data: undefined,
      isLoading: true,
      error: null,
      detail: undefined,
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    student() {
      if (!this.user || !this.user.student) return null
      return this.user.student.find(item => item.id === this.homework.student_id)
    },
    homework() {
      if (!this.data) return null
      return this.data.homework[0]
    },
    lessons() {
      if (!this.homework) return []
      return this.homework.lessonTitle
    },
    teacher() {
      if (!this.homework) return null
      return this.data.teacher.find(item => item.t_id === this.homework.schedule_time.t_id)
    },
    schedule() {
      if (!this.homework) return null
      return this.data.schedule.find(item => item.id === this.homework.schedule_time.s_id)
    },
    scheduleTimeUrl() {
      if (!this.schedule) return null
      return `/schedule/view/${this.schedule.id}?st_id=${this.homework.st_id}`
    },
    id() {
      const id = this.$route.query.id || this.$route.params.id
      return parseInt(id)
    },
    classDate() {
      if (!this.homework) return
      const startTime = this.$moment(this.homework.schedule_time.start_time)
      return startTime.format("YYYY年M月D日 dddd")
    },
    classTime() {
      if (!this.homework) return
      const startTime = this.$moment(this.homework.schedule_time.start_time)
      const endTime = this.$moment(this.homework.schedule_time.end_time)
      return `${startTime.format("H:mm")}-${endTime.format("HH:mm")}`
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getLessonById(id) {
      return this.lessons.find(e => e.lesson.id === id)
    },
    getLessonTitle(data) {
      let str = ""
      if (data.series) str += `${data.series.title}`
      if (data.book) str += ` / ${data.book.title}`
      if (data.unit) str += ` / ${data.unit.title}`
      if (data.lesson) str += str.length ? ` / ${data.lesson.title}` : data.lesson.title
      return str
    },
    async getData() {
      try {
        const data = await this.$api.homework.INFO(this.id)
        this.isLoading = false
        this.data = data
      } catch (error) {
        this.isLoading = false
        this.error = error.message
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "./style.scss";
#homework {
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
  .cover {
    background: #ffa501;
    height: 140px;
    width: 100%;
    display: flex;
    padding-top: 10px;
    justify-content: center;
    img {
      text-align: center;
      height: 155px;
      display: block;
      margin: 0 auto;
      position: absolute;
    }
  }
  .top {
    padding: 0px 5% 10px 5%;
    border-bottom: 1px solid #eee;
    .status {
      transform: none;
    }
  }
  .title {
    h3 {
      font-weight: bold;
      display: flex;
      font-size: 1.2rem;
      margin-bottom: 5px;
      span:last-child {
        margin-left: 5px;
      }
    }
    h5 {
      color: $blue;
      font-size: 0.9rem;
      font-weight: bold;
      transition: all 0.1s;
      &:active {
        opacity: 0.6;
      }
    }
  }
  .teacher {
    display: flex;
    align-items: center;
    span {
      font-size: 0.9rem;
    }
    .img {
      margin-right: 5px;
      $size: 35px;
      width: $size;
      height: $size;
      border-radius: 100%;
    }
  }
  .back {
    opacity: 0.6;
    font-size: 0.8rem;
    padding: 10px 5% 0 5%;
    transition: all 0.1s;
    display: inline-block;
    &:active {
      opacity: 1;
      color: $blue;
    }
    i {
      margin-right: 5px;
      font-weight: 400;
    }
  }
  .detail {
    margin-bottom: 15px;
  }
  .homework-item {
    background: #eee;
    padding: 5px 10px;
    border-radius: 4px;
    font-size: 0.9rem;
    margin-bottom: 5px;
    &:last-of-type {
      margin: 0;
    }
    .lesson {
      font-weight: bold;
    }
  }
  .html-content {
    ::v-deep .html,
    ::v-deep .html * {
      padding: 0;
      line-height: 1.3;
      margin-block-start: 0;
      margin-block-end: 0px;
      font-size: 0.9rem;
      word-break: break-word;
      white-space: pre-wrap;
      font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, PingFang SC, Microsoft YaHei,
        Source Han Sans SC, Noto Sans CJK SC, WenQuanYi Micro Hei, sans-serif;
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;
    }
  }
}
</style>
